<div>
    Summary: 
    <div>
        <h6>{{summary}}</h6>
    </div>
</div>
<div>
    <app-tag-list [tagString]="keyWords"></app-tag-list>

</div>
<table class="table table-striped ">
    <thead>
        <th scope="col">{{'Label' | i18n}}</th>
        <th scope="col">{{'Value' | i18n}}</th>
        <th scope="col" class="hide-on-mobile">{{'Score' | i18n}}</th>
    </thead>

    <tbody>
        <tr scope="row" *ngFor="let item of tableData; let i = index" 
            [class.trChosen]="item.chosen == true">


            <td><input type="text" [(ngModel)]="item.key" 
                    class="editable" (click)="tableItemDown($event, 'value', item)" (focusout)="itemFocusout()"></td>

            <td class="valueColumn"><input type="text" [(ngModel)]="item.value" class="editable"
                    (click)="tableItemDown($event, 'value', item)" (focusout)="itemFocusout()"
                    [style.color]="item.color"></td>

            <td class="hide-on-mobile"> % {{item.score*100 }}</td>
        </tr>
    </tbody>
    <div  (click)="downloadImg()">
        {{uid}}
    </div>
</table>